import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetSpacingsInputDto, SpacingCreateDto, SpacingDto, SpacingExcelDownloadDto, SpacingUpdateDto } from '../dtos/spacing/models';

@Injectable({
  providedIn: 'root',
})
export class SpacingService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: SpacingCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpacingDto>({
      method: 'POST',
      url: '/api/planning/spacings',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/spacings/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/spacings',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpacingDto>({
      method: 'GET',
      url: `/api/planning/spacings/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/spacings/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetSpacingsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<SpacingDto>>({
      method: 'GET',
      url: '/api/planning/spacings',
      params: { name: input.name, line: input.line, lineFrom: input.lineFrom, lineTo: input.lineTo, betweenLine: input.betweenLine, betweenLineFrom: input.betweenLineFrom, betweenLineTo: input.betweenLineTo, isVisible: input.isVisible, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: SpacingExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/spacings/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, line: input.line, lineFrom: input.lineFrom, lineTo: input.lineTo, betweenLine: input.betweenLine, betweenLineFrom: input.betweenLineFrom, betweenLineTo: input.betweenLineTo, isVisible: input.isVisible, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpacingDto[]>({
      method: 'GET',
      url: '/api/planning/spacings/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: SpacingUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpacingDto>({
      method: 'PUT',
      url: `/api/planning/spacings/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}